export { default } from './Avatar';


//////////////////
// WEBPACK FOOTER
// ../~/@material-ui/core/esm/Avatar/index.js
// module id = 543
// module chunks = 121